import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getServiceDetails, updateService } from "../../helpers/http_services_requests";
import { useQuery } from "@tanstack/react-query";
import { centsToReais, reaisToCents } from "../../utils/functions";

export default function ServiceUpdate() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getServiceDetails', id], 
        queryFn: () => getServiceDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: serviceData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Serviço - Editar",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "price",
                    label: "Preço",
                    type: "text",
                    mask: "currency",
                    required: true
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updateService({ ...data, price: reaisToCents(data.price) }, () => navigate('/servicos'));
    };

    return <DynamicFormPage 
        isLoading={isFetching} 
        initialData={serviceData ? { ...serviceData, price: centsToReais(serviceData.price) } : serviceData} 
        title={"Serviço - Editar"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
        onSubmit={handleSubmit} 
    />;
};
